import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import AddClient from './AddClient';
import {
  locationPinCode
} from "services/redux/sales/corporate/locations/action";
import {
  addClient
} from "services/redux/sales/corporate/pocDetails/action";
import {
  documentUploadUrl
} from "services/redux/fileUpload/action";
import {documentUploadUrlPublic} from "services/redux/fileUpload/action";

const mapStateToProps = (state) => ({
  pincodeData: state.locationReducer.pincodeData,
  documentUrlData: state.fileUploadReducer.documentUrlData,
  documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
  });
  
  const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
      {
        locationPinCode,
        addClient,
        documentUploadUrl,
        documentUploadUrlPublic
      },
      dispatch
    );
  
  export default connect(mapStateToProps, mapDispatchToProps)(AddClient);